import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle, Star } from 'lucide-react';
import * as LucideIcons from 'lucide-react';
import { services, testimonials } from '../data/mock';

export const Home = () => {
  return (
    <div className="page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Votre Jardin Mérite le Meilleur
            </h1>
            <p className="hero-description">
              Experts en entretien et aménagement d'espaces verts dans l'Hérault. 
              Transformons vos extérieurs en véritables havres de paix.
            </p>
            <div className="hero-buttons">
              <Link to="/contact" className="btn-primary">
                Demander un Devis
                <ArrowRight className="w-5 h-5" />
              </Link>
              <Link to="/services" className="btn-secondary">
                Nos Services
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <div className="features-grid">
            <div className="feature-card">
              <CheckCircle className="feature-icon" />
              <h3 className="feature-title">Professionnalisme</h3>
              <p className="feature-text">Équipe qualifiée et expérimentée</p>
            </div>
            <div className="feature-card">
              <CheckCircle className="feature-icon" />
              <h3 className="feature-title">Qualité Garantie</h3>
              <p className="feature-text">Travail soigné et résultats durables</p>
            </div>
            <div className="feature-card">
              <CheckCircle className="feature-icon" />
              <h3 className="feature-title">Service Local</h3>
              <p className="feature-text">Intervention dans tout le département</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Nos Services</h2>
            <p className="section-subtitle">
              Une gamme complète de services pour l'entretien et l'embellissement de vos espaces verts
            </p>
          </div>
          
          <div className="services-grid">
            {services.map((service) => {
              const Icon = LucideIcons[service.icon];
              return (
                <div key={service.id} className="service-card">
                  <div className="service-image-wrapper">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="service-image"
                    />
                    <div className="service-icon-overlay">
                      {Icon && <Icon className="w-8 h-8" />}
                    </div>
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">{service.title}</h3>
                    <p className="service-description">{service.description}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="text-center" style={{ marginTop: '48px' }}>
            <Link to="/services" className="btn-primary">
              Voir Tous Nos Services
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Ce Que Disent Nos Clients</h2>
            <p className="section-subtitle">
              Leur satisfaction est notre meilleure récompense
            </p>
          </div>

          <div className="testimonials-grid">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <div className="testimonial-stars">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="star-icon" fill="currentColor" />
                  ))}
                </div>
                <p className="testimonial-text">"{testimonial.text}"</p>
                <div className="testimonial-author">
                  <div>
                    <p className="testimonial-name">{testimonial.name}</p>
                    <p className="testimonial-location">{testimonial.location}</p>
                  </div>
                  <span className="testimonial-date">{testimonial.date}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">
              Prêt à Transformer Votre Jardin ?
            </h2>
            <p className="cta-description">
              Contactez-nous dès aujourd'hui pour un devis gratuit et personnalisé
            </p>
            <Link to="/contact" className="btn-cta">
              Demander un Devis Gratuit
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
